const createIntersectionObserver = (root, extraOptions = {}) => {
  const subscribers = new Map();

  const intersectionOptions = {
    root,
    rootMargin: '0px',
    threshold: 0.05,
    ...extraOptions
  };

  const intersectionObserver = new IntersectionObserver((entries) => {
    for (let entry of entries) {
      if (subscribers.has(entry.target)) {
        const existingSet = subscribers.get(entry.target);
        existingSet.forEach(callback => callback(entry));
      }
    }
  }, intersectionOptions);

  const subscribe = (observable, callback, observer = '') => {
    let existingSet;
    if (subscribers.get(observable)) {
      existingSet = subscribers.get(observable);
    } else {
      intersectionObserver.observe(observable);
      existingSet = new Set();
    }
    subscribers.set(observable, existingSet.add(callback));
    return () => {
      existingSet.delete(callback);
      if (existingSet.size === 0) {
        subscribers.delete(observable);
        intersectionObserver.unobserve(observable);
      } else {
        subscribers.set(observable, existingSet);
      }
    };
  }

  return {
    subscribeToIntersection: subscribe // Method to directly use in useEffect so that the observation is unobserved successfully
  };
};

export default createIntersectionObserver;